/* ================================================================
   Recently Viewed Products — Niimbot SG
   Tracks PDP views in localStorage and renders a horizontal carousel
   wherever a [data-nb-recently-viewed] container is rendered (PDP
   bottom, cart-page bottom, etc.).

   Storage:   localStorage key 'shopify_recently_viewed', max 10 items
   Public API: window.NbRecentlyViewed { items, clear }
   ================================================================ */
(function () {
  'use strict';

  var STORAGE_KEY = 'shopify_recently_viewed';
  var MAX_ITEMS = 10;

  /* ── Storage ───────────────────────────────────────────── */
  function read() {
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      var arr = raw ? JSON.parse(raw) : [];
      return Array.isArray(arr) ? arr : [];
    } catch (_) { return []; }
  }
  function write(arr) {
    try { localStorage.setItem(STORAGE_KEY, JSON.stringify(arr)); } catch (_) {}
  }

  /* ── Tracking (fires on PDP load) ──────────────────────── */
  function recordView() {
    var el = document.querySelector('[data-pdp-product-json]');
    if (!el) return;
    var product;
    try { product = JSON.parse(el.textContent.trim()); }
    catch (_) { return; }
    if (!product || !product.handle) return;

    var arr = read();
    arr = arr.filter(function (it) { return it.handle !== product.handle; });
    arr.unshift(product);
    if (arr.length > MAX_ITEMS) arr = arr.slice(0, MAX_ITEMS);
    write(arr);
  }

  /* ── Helpers ───────────────────────────────────────────── */
  function escHtml(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }
  function fmtMoney(cents) {
    if (typeof cents !== 'number' || isNaN(cents)) {
      var n = parseFloat(cents);
      if (isNaN(n)) return '';
      cents = n;
    }
    var d = cents / 100;
    return d % 1 === 0 ? 'S$' + d.toFixed(0) : 'S$' + d.toFixed(2);
  }

  /* ── Card renderer ─────────────────────────────────────── */
  function renderCard(item) {
    var url = item.url || (item.handle ? '/products/' + item.handle : '#');
    var img = item.image || '';
    var title = item.title || '';
    var priceCents = typeof item.price === 'number' ? item.price : parseInt(item.price, 10) || 0;
    var compareCents = typeof item.compare_at_price === 'number' ? item.compare_at_price
                     : parseInt(item.compare_at_price, 10) || 0;
    var onSale = compareCents > 0 && compareCents > priceCents;

    var quickAddAttrs =
      ' data-nb-rv-add' +
      ' data-product-handle="' + escHtml(item.handle || '') + '"' +
      ' data-product-title="' + escHtml(title) + '"';

    return (
      '<article class="nb-rv__card">' +
        '<a href="' + escHtml(url) + '" class="nb-rv__media" aria-label="' + escHtml(title) + '">' +
          (img ? '<img src="' + escHtml(img) + '" alt="' + escHtml(title) + '" loading="lazy">'
               : '<div class="nb-rv__placeholder" aria-hidden="true"></div>') +
          '<button type="button" class="nb-rv__quickAdd"' + quickAddAttrs + ' aria-label="Quick add ' + escHtml(title) + '">' +
            '<svg viewBox="0 0 24 24" width="13" height="13" fill="none" stroke="currentColor" stroke-width="2.25" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>' +
            '<span>Quick Add</span>' +
          '</button>' +
        '</a>' +
        '<a href="' + escHtml(url) + '" class="nb-rv__title">' + escHtml(title) + '</a>' +
        '<div class="nb-rv__prices">' +
          '<span class="nb-rv__price">' + fmtMoney(priceCents) + '</span>' +
          (onSale ? ' <s class="nb-rv__compare">' + fmtMoney(compareCents) + '</s>' : '') +
        '</div>' +
        '<button type="button" class="nb-rv__quickAdd nb-rv__quickAdd--mobile"' + quickAddAttrs + ' aria-label="Add ' + escHtml(title) + '">' +
          '<svg viewBox="0 0 24 24" width="13" height="13" fill="none" stroke="currentColor" stroke-width="2.25" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>' +
          '<span>Add</span>' +
        '</button>' +
      '</article>'
    );
  }

  /* ── Render to every container on the page ────────────── */
  function renderSlider() {
    var containers = document.querySelectorAll('[data-nb-recently-viewed]');
    if (!containers.length) return;
    var history = read();

    containers.forEach(function (container) {
      var section = container.closest('.nb-rv-section') || container.parentElement;
      var currentHandle = container.getAttribute('data-current-handle') || '';
      var minItems = parseInt(container.getAttribute('data-min-items'), 10) || 1;
      var renderList = history.filter(function (it) { return it.handle !== currentHandle; });

      if (renderList.length < minItems) {
        if (section) section.hidden = true;
        container.innerHTML = '';
        return;
      }

      container.innerHTML = renderList.map(renderCard).join('');
      if (section) section.hidden = false;
    });
  }

  /* ── Quick Add ─────────────────────────────────────────── */
  function quickAdd(btn) {
    var handle = btn.getAttribute('data-product-handle');
    if (!handle) return;

    if (btn.disabled) return;
    btn.disabled = true;
    var labelEl = btn.querySelector('span');
    var original = labelEl ? labelEl.textContent : '';
    if (labelEl) labelEl.textContent = 'Adding…';

    // Resolve first available variant via /products/<handle>.js so we
    // never push an out-of-stock variant into the cart.
    fetch('/products/' + handle + '.js', { credentials: 'same-origin', headers: { 'Accept': 'application/json' } })
      .then(function (r) { if (!r.ok) throw new Error('product fetch failed'); return r.json(); })
      .then(function (data) {
        var variant = (data.variants || []).find(function (v) { return v.available; }) || (data.variants || [])[0];
        if (!variant) throw new Error('no variants available');
        // If the product has more than one available variant, send the
        // shopper to the PDP so they can pick — auto-adding the wrong
        // colour/size is worse than a small redirect.
        var availableCount = (data.variants || []).filter(function (v) { return v.available; }).length;
        if (availableCount > 1) {
          window.location.href = data.url || ('/products/' + handle);
          return null;
        }
        var addUrl = ((window.routes && window.routes.cart_add_url) || '/cart/add') + '.js';
        return fetch(addUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [{ id: variant.id, quantity: 1 }] })
        });
      })
      .then(function (r) {
        if (!r) return; // redirected
        if (!r.ok) throw new Error('add to cart failed');
        if (window.NbCart) {
          return window.NbCart.refresh().then(function () { window.NbCart.open && window.NbCart.open(); });
        }
        document.dispatchEvent(new CustomEvent('cart:refresh'));
      })
      .then(function () {
        if (labelEl) labelEl.textContent = 'Added ✓';
        setTimeout(function () { btn.disabled = false; if (labelEl) labelEl.textContent = original; }, 1500);
      })
      .catch(function () {
        btn.disabled = false;
        if (labelEl) labelEl.textContent = original;
      });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-nb-rv-add]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    quickAdd(btn);
  });

  /* ── Init ─────────────────────────────────────────────── */
  function init() {
    recordView();
    renderSlider();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  /* ── Public API ───────────────────────────────────────── */
  window.NbRecentlyViewed = {
    items: function () { return read(); },
    clear: function () { write([]); renderSlider(); }
  };
})();
